import { createReducer } from 'typesafe-actions'
import * as actions from 'redux/actions'
import { Action, SystemState } from 'redux/reducers/interfaces'

export const initialState = {
    error: null,
    process: {}
}
export const systemReducer = createReducer<SystemState, Action>(initialState)
    .handleAction(actions.loadSystemConfig.request, (state) => ({
        ...state,
        process: {
            isLoading: true
        }
    }))
    .handleAction(actions.loadSystemConfig.success, (state, action) => ({
        ...state,
        value: action.payload,
        process: {
            isLoading: false,
            isLoaded: true
        }
    }))
    .handleAction(actions.loadSystemConfig.failure, (state, action) => ({
        ...state,
        error: action.payload,
        process: {}
    }))
